import React from 'react'
import { Navigate } from 'react-router-dom'

import { DashboardRoutes as dashboardRoutes } from '../pages/Dashboard'
import documentsRoutes from '../pages/Documents/DocumentRoutes'
import committeeRoutes from '../pages/Committees/CommitteeRoutes'
import dataSetupsRoutes from '../pages/DataSetups/DataSetupsRoutes'
import workflowRoutes from '../pages/Workflow/WorkflowRoutes'
import collaborationRoutes from '../pages/Collaboration/CollaborationRoutes'
import notificationRoutes from '../pages/Notifications/NotificationRoutes'
import reportsRoutes from '../pages/Reports/ReportsRoutes'
import auditsRoutes from '../pages/Audits/AuditsRoutes'

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Navigate to="/dashboard" />,
    },
]

const errorRoute = [
    {
        component: () => <Navigate to="/session/404" replace />,
    },
]

const themeExamplesRoutes =
    process.env.NODE_ENV === 'production'
        ? []
        : require('../pages/ThemeComponentsexamples/ThemeExamplesRoutes').default

const routes = [
    ...redirectRoute,
    ...dashboardRoutes,
    ...documentsRoutes,
    ...committeeRoutes,
    ...collaborationRoutes,
    ...notificationRoutes,
    ...dataSetupsRoutes,
    ...workflowRoutes,
    ...reportsRoutes,
    ...auditsRoutes,
    ...themeExamplesRoutes,
    ...errorRoute,
    { path: '*', component: () => <Navigate to="/session/404" replace /> },
]

export default routes
